import { api } from "@/lib/api";

const money = (c) => `$${((c || 0) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Opens a print-friendly tax receipt for a single gift and triggers the browser print dialog.
export async function printReceipt(donationId) {
  try {
    const r = await api.get(`/donations/${donationId}/receipt`);
    const d = r.data;
    const w = window.open("", "_blank", "width=720,height=820");
    if (!w) return;
    w.document.write(`<!doctype html><html><head><title>Donation receipt</title>
      <style>body{font-family:Georgia,'Times New Roman',serif;color:#2b2b2b;padding:48px;max-width:640px;margin:auto}
      h1{font-size:22px;margin:0 0 4px}.muted{color:#666;font-size:13px}hr{border:none;border-top:1px solid #ddd;margin:22px 0}
      .row{display:flex;justify-content:space-between;padding:6px 0;font-size:15px}</style></head><body>
      <h1>${d.org || "Receipt"}</h1>
      <div class="muted">Official donation receipt${d.ein ? ` &middot; EIN ${d.ein}` : ""}</div>
      <hr/>
      <div class="row"><span>Donor</span><strong>${d.donor_name || "—"}</strong></div>
      <div class="row"><span>Date</span><strong>${d.date || ""}</strong></div>
      <div class="row"><span>Designation</span><strong>${d.campaign_title || ""}</strong></div>
      <div class="row"><span>Method</span><strong>${(d.method || "").toUpperCase()}</strong></div>
      <div class="row"><span>Amount</span><strong>${money(d.amount_cents)}</strong></div>
      <hr/>
      <p class="muted">${d.tax_statement || ""}</p>
      ${d.simulated ? '<p class="muted"><b>SIMULATED — not a real charge.</b></p>' : ""}
      <script>window.onload=function(){setTimeout(function(){window.print();},250);}</script>
      </body></html>`);
    w.document.close();
  } catch (e) { /* noop */ }
}
